import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class SuggestionController extends AuthenticatedController {
  static getAll(botId) {
    return super.get(APIRoutes.SUGGESTIONS(botId));
  }

  static ignoreSuggestion(botId, suggestionId) {
    return super.put(APIRoutes.IGNORE_SUGGESTION(botId), {
      responseMissId: suggestionId,
    });
  }
}
